// extracted by mini-css-extract-plugin
export default {"AsideBar":"Aside_Bar_Social_Media_AsideBar__entyg"};